import { render, staticRenderFns } from "./AcceptHistoryCard.vue?vue&type=template&id=7219782e&scoped=true"
import script from "./AcceptHistoryCard.vue?vue&type=script&lang=js"
export * from "./AcceptHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./AcceptHistoryCard.vue?vue&type=style&index=0&id=7219782e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7219782e",
  null
  
)

export default component.exports